import { render, staticRenderFns } from "./MFONews.vue?vue&type=template&id=7c8d5848&scoped=true"
import script from "./MFONews.vue?vue&type=script&lang=js"
export * from "./MFONews.vue?vue&type=script&lang=js"
import style0 from "./MFONews.vue?vue&type=style&index=0&id=7c8d5848&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8d5848",
  null
  
)

export default component.exports